import React, {useState, useMemo} from "react";
import { 
  Tooltip, 
  Spinner,  
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem 
} from "reactstrap";

import ImageViewer from "./ImageViewer";
import { useDispatch, connect } from "react-redux";
import { avatarColors } from "util/DataList";

const highlight = (text="", qLower="") => {
  if (!qLower) return [text];
  const t = text.toLowerCase(); const res=[]; let i=0, idx;
  while ((idx = t.indexOf(qLower, i)) !== -1) { if (idx>i) res.push(text.slice(i,idx)); res.push(<span key={idx} className="msgr-mark">{text.slice(idx,idx+qLower.length)}</span>); i=idx+qLower.length; }
  if (i<text.length) res.push(text.slice(i)); return res;
};
function MessageList({ messages = [], currentUserEmail, searchQuery, setRowRef, studentData, presenceItems, readOnly }) {

  const [viewer, setViewer] = React.useState({ open:false, url:"" });
  
  const dispatch = useDispatch();

  function groupMessagesByDate(messages) {
    return messages.reduce((groups, msg) => {
      const d = msg.createdAt?.toDate ? msg.createdAt.toDate() : new Date(msg.createdAt);
      const dayKey = d.toDateString(); // "Mon Sep 29 2025"
      if (!groups[dayKey]) groups[dayKey] = [];
      groups[dayKey].push(msg);
      return groups;
    }, {});
  }

  function formatDayLabel(dateStr) {
    const d = new Date(dateStr);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (d.toDateString() === today.toDateString()) return "Today";
    if (d.toDateString() === yesterday.toDateString()) return "Yesterday";

    return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  }

  const grouped = groupMessagesByDate(messages);

  function shouldShowAvatar(msgs, index) {
    if (!msgs || msgs.length === 0) return false; // no messages

    if (index === 0) return true; // first message in group

    const prev = msgs[index - 1];
    const current = msgs[index];

    // safeguard if prev or current is missing
    if (!prev || !current) return false;

    return prev.senderEmail !== current.senderEmail;
  }

  function formatTime(date) {
    if (!date) return "";
    return date.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).replace(" AM", "AM").replace(" PM", "PM");
  }

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  
  function shuffle(array) {
    let arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  const shuffledColors = useMemo(() => shuffle(avatarColors), []);

  const presenceMap = useMemo(
    () => Object.fromEntries((presenceItems || []).map(p => [p.email, p])),
    [presenceItems]
  );

  function getColorForEmail(email) {
    if (!email) return avatarColors[0]; // default fallback
    let hash = 0;
    for (let i = 0; i < email.length; i++) {
      hash = email.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % avatarColors.length;
    return avatarColors[index];
  }


  return (
    <>
      {viewer.open && (
        <ImageViewer
          isOpen={viewer.open}
          url={viewer.url}
          toggle={() => setViewer({ open: false, url: "" })}
        />
      )}
      {Object.entries(grouped).map(([dayKey, msgs]) => (
        <div key={dayKey}>

          <div className="text-center my-3">
            <span className="badge bg-info text-white px-3 py-1">
              {formatDayLabel(dayKey)}
            </span>
          </div>
          
          {msgs.map((msg, i) => {

            const mine = msg.senderEmail === currentUserEmail;
            const showAvatar = shouldShowAvatar(msgs, i);
            const group = msg.participantsEmails?.length > 2? true : false;

            if (msg.type === "system") {
              return (
                <div key={msg.id} className="msgr-system text-center text-muted text-xs font-weight-500 my-2">
                  {msg.event === "member_added" && `${msg.actor} added ${msg.target || msg.extra?.target}`}
                  {msg.event === "member_removed" && `${msg.actor} removed ${msg.target || msg.extra?.target}`}
                  {msg.event === "group_rename" && `${msg.actor} renamed the group to "${msg.newName || msg.extra?.newName}"`}
                  {msg.event === "pinned" && `${msg.actor} pinned a message`}
                  {msg.event === "unpinned" && `${msg.actor} unpinned a message`}
                </div>
              );
            }



            return (
              <div key={msg.id} className={`msgr-row ${mine ? 'me flex-row-reverse justify-content-start' : 'them'}`} ref={(el)=>setRowRef?.(msg.id, el)}>
                {/* {viewer.open && <ImageViewer isOpen={viewer.open} url={viewer.url} toggle={()=>setViewer({open:false,url:""})} />} */}


                {/* Avatar */}
               
                {(!mine && group) || readOnly ? showAvatar  ? (
                  
                  <div>
                  <div className="position-relative mx-2" id={`avatar-${msg.id}`}>
                    { !studentData.find(data => data.email == msg.senderEmail)?.profilePicture ? 
                    <div  style={{ minWidth: 28, minHeight: 28 , maxWidth: 28, maxHeight: 28}} className={"msgr-avatar text-white "+ getColorForEmail(msg.senderEmail) }><span>{(msg.senderName || msg.senderEmail ||"?").slice(0,1).toUpperCase()}</span>
                    
                    </div>
                    :
                  <img 
                        src={"https://storage.googleapis.com/pre-dental-tracker.appspot.com/profile-picture/" + studentData.find(data => data.email == msg.senderEmail)?.profilePicture}
                        className="msgr-avatar border border-dark" 
                        alt="..." 
                        

                        style={{objectFit:"cover", minWidth: 28, minHeight: 28 , maxWidth: 28, maxHeight: 28}}

                    /> }

                  
                    
                    <span className={`position-absolute bottom--1 end-0 fas fa-circle msgr-dot  ${presenceMap[msg.senderEmail]?.online ? 'text-success':'text-gray'}`} style={{fontSize:"12px"}} />
                    
                    <Tooltip
                      key={`avatar-${msg.id}`}
                      isOpen={tooltipOpen}
                      target={`avatar-${msg.id}`}
                      toggle={toggle}
                      placement="top"
                    >
                      {msg.senderName+" ("+msg.senderEmail+") "}
                    </Tooltip>   
                  
                  </div>
                  </div>
                ) : (
                  <div style={{ width: 28, height: 28,  }} className="mx-2" /> // keep spacing
                ) : ""}

                
                <div className={`msgr-bubble font-weight-500 text-sm ${mine ? 'bg-default text-white' : 'them'}`}>
                  {/* {!!msg.text && <div>{highlight(msg.text, searchQuery)}</div>} */}
                  {/* {!!msg.text && (
                    <div>
                      {highlight(msg.text, searchQuery).map((part, i) => {
                        if (typeof part !== "string") return part; // highlighted span
                        // linkify URLs
                        const pieces = [];
                        const re = /(https?:\/\/[^\s]+)/gi;
                        let lastIndex = 0, m;
                        while ((m = re.exec(part)) !== null) {
                          if (m.index > lastIndex) pieces.push(part.slice(lastIndex, m.index));
                          pieces.push(
                            <a key={`${i}-${m.index}`} href={m[0]} target="_blank" rel="noopener noreferrer">{m[0]}</a>
                          );
                          lastIndex = re.lastIndex;
                        }
                        if (lastIndex < part.length) pieces.push(part.slice(lastIndex));
                        return <React.Fragment key={i}>{pieces}</React.Fragment>;
                      })}
                    </div>
                  )} */}

                  {!!msg.text && (
                    <div className="font-weight-500">
                      {highlight(msg.text, searchQuery).map((part, i) => {
                        if (typeof part !== "string") return part;
                        const pieces=[]; const re=/(https?:\/\/[^\s]+)/gi; let last=0, m;
                        while ((m = re.exec(part)) !== null) {
                          if (m.index > last) pieces.push(part.slice(last, m.index));
                          pieces.push(<a key={`${i}-${m.index}`} href={m[0]} target="_blank" className="font-weight-bold" rel="noopener noreferrer">{m[0]}</a>);
                          last = re.lastIndex;
                        }
                        if (last < part.length) pieces.push(part.slice(last));
                        return <React.Fragment key={i}>{pieces}</React.Fragment>;
                      })}
                    </div>
                  )}

                  {/* {Array.isArray(msg.attachments) && msg.attachments.length > 0 && (
                    <div className="d-grid gap-2 mt-1">
                      {msg.attachments.map((a,i) => a.type === "image" ? (
                        <div key={i}><img src={a.url} alt={a.name} loading="lazy" className="img-fluid rounded" /><div className="small text-muted">{a.name}</div></div>
                      ) : (
                        <div key={i} className="small"><a href={a.url} target="_blank" rel="noopener noreferrer">{a.name || "Download file"}</a>{a.size ? <span className="text-muted ms-2">({(a.size/1048576).toFixed(2)} MB)</span> : null}</div>
                      ))}
                    </div>
                  )} */}

                  {Array.isArray(msg.attachments) && msg.attachments.length > 0 && (() => {
                    const imgs = msg.attachments.filter(a => a.type === "image");
                    const files = msg.attachments.filter(a => a.type !== "image");

                    return (
                      <div className="mt-3">
                        {imgs.length > 0 && (
                          <div className={`msgr-img-grid cols-${imgs.length >= 3 ? 3 : imgs.length}`}>
                            {imgs.map((a, i) => {
                              const progress = msg.attachments[i].progress;

                              return (
                              <div key={i} className="position-relative">
                                {!a.url?<>
                                
                                <p className="p-0 m-0" style={{visibility:"hidden",overflowInline:"scroll",maxHeight:"0px", display:"block"}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                                
                                <div className="bg-light text-center py-3" style={{borderRadius:"8px"}} >
                                  <Spinner
                                    color="default"
                                    type="grow"
                                    size="sm"
                                  >
                                  </Spinner>

                                </div></> : <img
                                  src={a.url || (a.file && URL.createObjectURL(a.file))}
                                  alt={a.name}
                                  className="msgr-img"
                                  style={{ objectFit:"cover"}}
                                  onClick={()=>setViewer({ open:true, url:a.url })}
                                />}
                             
                                {!a.url && (
                                  <div style={{
                                    position: "absolute", bottom: 0, left: 0, right: 0,
                                    height: "6px", background: "rgba(255,255,255,0.3)",
                                    borderRadius: "0 0 8px 8px"
                                  }}>
                                    <div style={{
                                      width: `${progress}%`,
                                      height: "100%",
                                      background: "#11cdef",
                                      borderRadius: "0 0 8px 8px"
                                    }} />
                                   
                                  </div>
                                )}
                              </div>
                            )})}
                          </div>
                        )}

                        {files.length > 0 && (
                          <div className="d-grid gap-2 mt-3">
                            {files.map((a, i) => {
                              const progress = msg.attachments[i].progress;
                              return (
                              <div key={i} className="font-weight-600">
                                <a href={a.url} target="_blank" rel="noopener noreferrer" className="text-info">{a.name || "Download file"}</a>
                                {a.size ? <span className="text-muted ms-2"> ({(a.size/1048576).toFixed(2)} MB)</span>: null }
                                {!a.url && (
                                  <div className="progress mt-1" style={{ height: "4px" }}>
                                    <div
                                      className="progress-bar"
                                      role="progressbar"
                                      style={{ width: `${progress}%` }}
                                    />
                                    <>{progress}</>
                                  </div>
                                )}
                              </div>
                            )})}
                          </div>
                        )}
                      </div>
                    );
                  })()}



                  <div className={"d-flex align-items-center mt-1 justify-content-between " + (mine ? "" : "flex-row-reverse")} >
                    {/* <div className="msgr-meta">
                      {(msg.senderName || msg.senderEmail)} · {msg.createdAt?.toDate ? msg.createdAt.toDate().toLocaleString() : ""}
                      {msg._status === "failed" && <span className="text-danger ms-2">Failed</span>}
                    </div>

                    {Array.isArray(msg.readBy) && msg.readBy.length > 0 && (
                      <div className="mt-1 d-flex align-items-center gap-1">
                        {msg.readBy.slice(0,6).map((e,i)=>(
                          <span key={i} title={`${e} read`} className="msgr-avatar" style={{ width:18, height:18, fontSize:10, borderRadius:"50%" }}>
                            {(e[0] || "").toUpperCase()}
                          </span>
                        ))}
                        {msg.readBy.length > 6 && <span className="small text-muted">+{msg.readBy.length-6}</span>}
                      </div>
                    )} */}
                    
                    <div>{msg.pinned ? <i class={"fas fa-thumbtack text-purple " + (mine ? "pr-2" : "pl-2")}></i> : ""}</div>
                    <div className={"msgr-meta text-gray font-weight-bold d-flex " + (mine ? "" : "flex-row-reverse")}>
                      <div>{msg.createdAt?.toDate ? formatTime(msg.createdAt.toDate()) : ""}</div>&nbsp;&nbsp;
                      <div>{(() => {
                        const others = (msg.participantsEmails || []).filter(e => e !== (msg.senderEmail || ""));
                        const readByOthers = (msg.readBy || []).filter(e => e !== (msg.senderEmail || ""));
                        const allRead = others.length > 0 && others.every(e => readByOthers.includes(e));
                        return allRead ? <i class="fas fa-check-double text-md text-success"></i> : <i class="fas fa-check text-gray"></i>;
                      })()}
                      </div>
                    </div>

                    {/* {Array.isArray(msg.readBy) && msg.readBy.length > 0 && (
                      <div className="mt-1 d-flex align-items-center gap-1">
                        {msg.readBy.filter(e => e !== msg.senderEmail).slice(0,6).map((e,i)=>(
                          <span key={i} title={`${e} read`} className="msgr-avatar" style={{ width:18, height:18, fontSize:10, borderRadius:"50%" }}>
                            {(e[0] || "").toUpperCase()}
                          </span>
                        ))}
                        {msg.readBy.length > 7 && <span className="small text-muted">+{msg.readBy.length-7}</span>}
                      </div>
                    )} */}


                    {/* <button className="btn btn-sm btn-light" onClick={()=>{
                      import("../../redux/Messages/MessagesAction").then(({ togglePinMessage }) => {
                        togglePinMessage({ messageId: msg.id, pinned: !msg.pinned })(()=>{},()=>{});
                      });
                    }}>{msg.pinned ? "Unpin" : "Pin"}</button> */}

                    


                  </div>

                  


                </div>
                
                    <div className={" d-flex align-items-center mx-2 " + (mine && "flex-row-reverse")}>
                      {/* <button
                        className="btn rounded-circle bg-lighter p-0 mx-1"
                        onClick={() => {
                          import("../../redux/Messages/MessagesAction").then(({ togglePinMessage }) => {
                            dispatch(togglePinMessage({ messageId: msg.id, pinned: !msg.pinned }));
                          });
                        }}
                      >
                      {msg.pinned ? <i class="fas fa-thumbtack p-2 text-indigo"></i> : <i class="fas text-sm fa-thumbtack  p-2 text-gray"></i>}
                      </button> */}

                      <UncontrolledDropdown direction="down" className="mx-1">
                        <DropdownToggle
                          disabled={readOnly}
                          caret={false}
                          className="btn rounded-circle bg-lighter  p-0 border-0 m-0 shadow-none"
                        >
                          <i className="fas fa-ellipsis-h p-2 text-gray"></i>
                        </DropdownToggle>
                        <DropdownMenu right={mine} className="mx-2" style={{width:"120px",minWidth:"120px"}}>
                          <DropdownItem className="text-xs font-weight-bolder text-default py-1 btn-white shadow-none" 
                            onClick={() => {
                              import("../../redux/Messages/MessagesAction").then(({ togglePinMessage }) => {
                                dispatch(togglePinMessage({ messageId: msg.id, pinned: !msg.pinned }));
                              });
                            }}
                          >
                            {msg.pinned ? "Unpin" : "Pin"}
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>




                      {(() => {
                        const e = "❤️";
                        const users = msg.reactions?.[e] || [];
                        const mine = users.includes(currentUserEmail);
                        const count = users.length || 0;
                        
                        return (
                          <>
                          
                            <button disabled={readOnly} className="btn rounded-circle btn-secondary bg-lighter border-0 p-0 mx-1 shadow-none"
                            onClick={()=>{
                              import("../../redux/Messages/MessagesAction").then(({ toggleReaction }) => {
                                toggleReaction({ messageId: msg.id, emoji: e, meEmail: currentUserEmail, add: !mine })(()=>{},()=>{});
                              });
                            }}>{mine ?<i class="fas fa-heart text-danger p-2"></i> : <i class="fas fa-heart text-gray p-2"></i>}</button>
                            
                            {(count == 1 && !mine) || count == 2  ? <div className={"bg-lighter rounded-circle text-xs "+ (group && "p-1")}><i class={"fas fa-heart text-danger " + (!group && "p-2")}><span className="font-weight-bolder text-dark" style={{fontFamily:"Open Sans, sans-serif"}}>&nbsp;{group && count}</span></i></div> : ""}

                          </>
                        );
                      })()}
                      
                    </div>
                  

                  {/* {!msg.pinned && (
                    <div className=" d-flex gap-1 align-items-center mx-2">
                      {(() => {
                        const e = "❤️";
                        const users = msg.reactions?.[e] || [];
                        const mine = users.includes(currentUserEmail);
                        const count = users.length || "";
                        return (
                          <button className={`btn btn-sm ${mine ? 'btn-primary' : 'btn-light'} `}
                            onClick={()=>{
                              import("../../redux/Messages/MessagesAction").then(({ toggleReaction }) => {
                                toggleReaction({ messageId: msg.id, emoji: e, meEmail: currentUserEmail, add: !mine })(()=>{},()=>{});
                              });
                            }}>{e} {count}</button>
                        );
                      })()}

                    </div>
                  )} */}

              </div>
            );
      })}</div>
    ))}
    </>
  );
}


export default connect(
  (s) => ({
    presenceItems: s.presence.items
  }),
  null
)(MessageList);